module.exports = __webpack_public_path__ + "static/media/teal-upload.a91d86cb.png";